import { Position } from "@xyflow/react";
import { CanvasPoint } from "../ownership.types";

export const OWNERSHIP_DROP_ZONE_HANDLE_ID = "drop-anywhere";
export const OWNERSHIP_SOURCE_HANDLE_HIT_AREA_PX = 20;

const OWNERSHIP_EXTRA_SOURCE_POSITIONS = [
    Position.Top,
    Position.Left,
    Position.Right,
] satisfies Position[];

export interface OwnershipSourceHandle {
    id?: string;
    position: Position;
}

export interface CardBounds {
    x: number;
    y: number;
    width: number;
    height: number;
}

export function getOwnershipSourceHandleStyle(): {
    width: number;
    height: number;
} {
    return {
        width: OWNERSHIP_SOURCE_HANDLE_HIT_AREA_PX,
        height: OWNERSHIP_SOURCE_HANDLE_HIT_AREA_PX,
    };
}

export function getOwnershipSourceHandles(): OwnershipSourceHandle[] {
    return [
        { position: Position.Bottom },
        ...OWNERSHIP_EXTRA_SOURCE_POSITIONS.map((position) => ({
            id: `source-${position}`,
            position,
        })),
    ];
}

const AXIS_EPSILON = 1e-9;

export function getCardBorderPoint(
    from: CanvasPoint,
    card: CardBounds,
): CanvasPoint | null {
    const { x, y, width, height } = card;
    const dx = x + width / 2 - from.x;
    const dy = y + height / 2 - from.y;

    let tEnter = 0;
    let tExit = 1;

    if (Math.abs(dx) < AXIS_EPSILON) {
        if (from.x < x || from.x > x + width) {
            return null;
        }
    } else {
        const t1 = (x - from.x) / dx;
        const t2 = (x + width - from.x) / dx;
        tEnter = Math.max(tEnter, Math.min(t1, t2));
        tExit = Math.min(tExit, Math.max(t1, t2));
    }

    if (Math.abs(dy) < AXIS_EPSILON) {
        if (from.y < y || from.y > y + height) {
            return null;
        }
    } else {
        const t1 = (y - from.y) / dy;
        const t2 = (y + height - from.y) / dy;
        tEnter = Math.max(tEnter, Math.min(t1, t2));
        tExit = Math.min(tExit, Math.max(t1, t2));
    }

    if (tEnter >= tExit || tEnter <= 0 || tEnter >= 1) {
        return null;
    }
    return { x: from.x + dx * tEnter, y: from.y + dy * tEnter };
}
